module.exports = __webpack_public_path__ + "static/media/mobile-careers-main-bg.5b3e8044.svg";